const INSUFFICIENT_DATA_LABEL = 'Insufficient Data';
const SYNCING_LABEL = 'Syncing';
const SYNCING_DATA_LABEL = 'Syncing Data';
const SYNCING_DATA_DESCRIPTION =
  "We'll let you know when this information is ready.";

export const MEMBER_ONBOARDING = {
  TITLE: 'of your {PROVIDER_NAME} team is onboarded',
  BACKUP_TITLE: 'Sign up your team',
};

export const ONBOARDING_MEETING = {
  TITLE: 'Schedule an Onboarding Meeting!',
  DESCRIPTION:
    "If you haven't already, please schedule a quick phone call with our onboarding team so we can get to know you and your development team needs!",
  SCHEDULE_MEETING_BUTTON_LABEL: 'Schedule Meeting',
};

export const QUESTIONS = {
  TITLE: 'Questions?',
};

export const AVERAGE_COMMENTS = {
  TITLE: 'Comments per review',
  PREVIOUS_PERIOD: 'PREVIOUS PERIOD: {NUM_COMMENTS}',
  GO_TO_METRICS: 'Details',
};

export const CODE_REVIEWS_COMPLETED = {
  TITLE: 'Code reviews completed',
  PREVIOUS_PERIOD: 'PREVIOUS PERIOD: {NUM_CODE_REVIEWS}',
  GO_TO_METRICS: 'Details',
};

export const REVIEW_LIFECYCLE_STAT = {
  TITLE: 'Review lifecycle (hours)',
  PREVIOUS_PERIOD: 'PREVIOUS PERIOD: {NUM_HOURS}',
  GO_TO_METRICS: 'Details',
};

export const LINES_PER_REVIEW = {
  TITLE: 'Lines per review',
  PREVIOUS_PERIOD: 'PREVIOUS PERIOD: {NUM_LINES}',
  GO_TO_METRICS: 'Details',
};

export const CONTRIBUTION_VOLUME = {
  TITLE: 'Contribution Volume',
  TOOLTIP:
    'Displays the lines added and removed for all of your connected projects.',
  GO_TO_METRICS_LINK: 'See Details',
  LINES_ADDED_TOOLTIP_TEXT: 'Lines added:',
  LINES_REMOVED_TOOLTIP_TEXT: 'Lines removed:',
  XAXIS_LABEL: 'Date',
  YAXIS_LABEL: 'Lines',
};

export const REVIEW_LIFECYCLE = {
  TITLE: 'Review Lifecycle Duration',
  TOOLTIP:
    'The average duration in hours that a code review is in progress from open to merge.',
  GO_TO_METRICS_LINK: 'See Details',
  HOURS_TOOLTIP_TEXT_PLURAL: '{NUM_HOURS} hours',
  HOURS_TOOLTIP_TEXT_SINGULAR: '{NUM_HOURS} hour',
  XAXIS_LABEL: 'Date',
  YAXIS_LABEL: 'Hours',
};

export const BIGGEST_CHANGES = {
  TITLE: 'Biggest Changes',
  TOOLTIP:
    'Metrics with the largest percentage change between the current and previous period.',
  GO_TO_METRICS_LINK: 'Go to Metrics',
  AVERAGE_COMMENTS_PER_REVIEW_SUBTITLE: 'Average Comments Per Review',
  AVERAGE_DEFECTS_SUBTITLE: 'Average Defects Caught During Review',
  AVERAGE_INLINE_COMMENTS_SUBTITLE: 'Average Inline Comments Per Review',
  AVERAGE_REVIEWER_LATENCY_HOURS_SUBTITLE: 'Average Reviewer Latency Hours',
  AVERAGE_REVIEW_LIFECYCLE_HOURS_SUBTITLE: 'Average Review Lifecycle Hours',
  AVERAGE_LINE_COUNTS_PER_REVIEW_SUBTITLE: 'Average Line Counts Per Review',
  AVERAGE_TEST_LINE_COUNTS_PER_REVIEW_SUBTITLE:
    'Average Test Line Counts Per Review',
  DEFECT_RATE_SUBTITLE: 'Issue Catch Rate',
  PERCENT_TEST_LINES_PER_REVIEW_SUBTITLE: 'Percent Test Lines Per Review',
  TOTAL_CODE_REVIEWS_COMPLETED_SUBTITLE: 'Total Code Reviews Completed',
  TOTAL_INLINE_COMMENTS_SUBTITLE: 'Total Inline Comments',
  TOTAL_DEFECTS_SUBTITLE: 'Issues Caught During Review',
  TOTAL_COMMENTS_SUBTITLE: 'Total Comments',
  TOTAL_LINE_COUNTS_SUBTITLE: 'Total Lines Merged',
  TOTAL_TEST_LINE_COUNTS_SUBTITLE: 'Total Test Lines Merged',
  TOTAL_ADDITIONS_SUBTITLE: 'Total Lines Added',
  TOTAL_DELETIONS_SUBTITLE: 'Total Lines Deleted',
  PRIOR_PERIOD_LABEL: 'Prior Period:',
  CURRENT_PERIOD_LABEL: 'Current Period:',
  INSUFFICIENT_DATA_LABEL,
  INSUFFICIENT_DATA_DESCRIPTION:
    "It looks like this organization doesn't have enough data in the current or previous period to display change data.",
  SYNCING_DATA_LABEL,
  SYNCING_DATA_DESCRIPTION,
};

export const REVIEWER_HIGHLIGHTS = {
  TITLE: 'Reviewer Highlights',
  TOOLTIP: 'Reviewers that caught the most issues',
  ISSUES_CAUGHT: '{NUM_ISSUES_CAUGHT} issues caught',
  INSUFFICIENT_DATA_LABEL,
  SYNCING_LABEL,
  GO_TO_METRICS_LINK: 'Details',
};

export const PROJECT_HIGHLIGHTS = {
  TITLE: 'Project Highlights',
  TOOLTIP: 'Projects with the highest merge volume',
  LINES_LABEL_PLURAL: '{NUM_LINES} lines',
  LINES_LABEL_SINGULAR: '{NUM_LINES} line',
  INSUFFICIENT_DATA_LABEL,
  SYNCING_LABEL,
  GO_TO_METRICS_LINK: 'Details',
};

export const AUTHOR_HIGHLIGHTS = {
  TITLE: 'Author Highlights',
  TOOLTIP: 'Authors with the highest test percentage of total code written',
  TEST_PERCENT_LABEL: '{TEST_PERCENT} tests',
  INSUFFICIENT_DATA_LABEL,
  SYNCING_LABEL,
  GO_TO_METRICS_LINK: 'Details',
};

export const DID_YOU_KNOW = {
  TITLE: 'Did you know?',
  INSUFFICIENT_DATA_LABEL,
  SYNCING_LABEL,
};

export const INDUSTRY_BENCHMARK_STANDINGS = {
  TITLE: 'Industry Benchmark Standings',
  TOOLTIP:
    "Your team's metric standings compared to lower, median, and upper quartile data of similar teams.",
  GO_TO_BENCHMARKS_LINK: 'Go to Benchmarks',
  ISSUE_CATCH_RATE_SUBTITLE: 'Issue Catch Rate',
  CODE_REVIEW_SIZE_SUBTITLE: 'Code Review Size',
  CODE_REVIEW_LIFECYCLE_DURATION_SUBTITLE: 'Code Review Lifecycle Duration',
  REVIEWER_RESPONSE_LATENCY_SUBTITLE: 'Reviewer Response Latency',
  TEST_PERCENTAGE_SUBTITLE: 'Test Percentage',
  LOWER_STANDING: 'Lower',
  MEDIAN_STANDING: 'Median',
  UPPER_STANDING: 'Upper',
  INSUFFICIENT_DATA_LABEL,
  INSUFFICIENT_DATA_DESCRIPTION:
    "There isn't enough data for your organization to currently calculate meaningful benchmarks. Check back once you have at least 5 from the past 30 days.",
  SYNCING_DATA_LABEL,
  SYNCING_DATA_DESCRIPTION,
};

export const ORGANIZATION_BREAKDOWN = {
  TITLE: 'Organization Breakdown',
  TOOLTIP:
    'Displays a language breakdown of all of your connected projects as well as the total number of files (excluding generated files)',
  VIEW_CURRENT_PERIOD_LINK: 'View current period only',
  VIEW_AGGREGATE_LINK: 'View aggregate',
  FILES_LABEL_PLURAL: '{NUM_FILES} files',
  FILES_LABEL_SINGULAR: '{NUM_FILES} file',
  LINES_LABEL_PLURAL: '{NUM_LINES} lines',
  LINES_LABEL_SINGULAR: '{NUM_LINES} line',
  ADDED_LABEL: 'added',
  INSUFFICIENT_DATA_LABEL,
  INSUFFICIENT_DATA_CURRENT_PERIOD_DESCRIPTION:
    'No data for the current period. Select "View aggregate" to view your aggregate organization breakdown.',
  INSUFFICIENT_DATA_AGGREGATE_DESCRIPTION:
    'No aggregate data available. Select "View current period only" to view your organization breakdown for the current period.',

  SYNCING_DATA_LABEL,
};

export const PULL_REQUEST_CONTRIBUTION = {
  TITLE: 'PullRequest Review Contribution',
  TOOLTIP:
    'The percentage of PullRequest network reviews completed versus those completed by members of your team. This takes into account only {PR_NAME} that have been merged.',
  PULL_REQUEST_PERCENT: 'PullRequest Reviews',
  NUM_REVIEWS_COMPLETED: '{NUM_REVIEWS} reviews completed',
  INTERNAL_REVIEW_PERCENT: 'Internal-only Reviews',
  INSUFFICIENT_DATA_LABEL,
  INSUFFICIENT_DATA_DESCRIPTION:
    'Your organization must have at least 1 pull request in the current period to display this information.',
  SYNCING_DATA_LABEL,
  SYNCING_DATA_DESCRIPTION,
};

export const DASHBOARD = {
  PAGE_TITLE: 'Organization Insights',
  PAGE_SUBTITLE_PLURAL:
    'Displaying aggregated data from merged {PR_NAME} across {NUM_PROJECTS} projects over the last {NUM_DAYS} days. This includes activity from your connected projects as a whole and not only reviews that PullRequest reviewers have reviewed.',
  PAGE_SUBTITLE_SINGULAR:
    'Displaying aggregated data from merged {PR_NAME} across your project over the last {NUM_DAYS} days. This includes activity from your connected projects as a whole and not only reviews that PullRequest reviewers have reviewed.',
  PAGE_SUBTITLE_PLURAL_METRICS_ONLY:
    'Displaying aggregated data from merged {PR_NAME} across {NUM_PROJECTS} projects over the last {NUM_DAYS} days. This includes activity from your connected projects as a whole.',
  PAGE_SUBTITLE_SINGULAR_METRICS_ONLY:
    'Displaying aggregated data from merged {PR_NAME} across your project over the last {NUM_DAYS} days. This includes activity from your connected projects as a whole.',
  PAGE_SUBTITLE_NO_PROJECTS:
    'Set up a project in order to see Organization Insights',
  BREADCRUMB_TITLE: 'Insights',
  EMERGENCY_BANNER_TITLE: 'Currently unavailable:',
  EMERGENCY_BANNER_DESCRIPTION:
    'Please return to the Dashboard when Organization Insights are available.',
  SYNCING_BANNER_TITLE: 'Processing…',
  SYNCING_BANNER_DESCRIPTION:
    "We're currently backfilling your organization's {REVIEW_WORDING} data. We'll notify you via email once your dashboard is up to date. In the meantime, check out some helpful tools to get your team started below.",
  QUESTIONS,
  MEMBER_ONBOARDING,
  ONBOARDING_MEETING,
  AVERAGE_COMMENTS,
  CODE_REVIEWS_COMPLETED,
  REVIEW_LIFECYCLE_STAT,
  LINES_PER_REVIEW,
  CONTRIBUTION_VOLUME,
  REVIEW_LIFECYCLE,
  BIGGEST_CHANGES,
  REVIEWER_HIGHLIGHTS,
  PROJECT_HIGHLIGHTS,
  AUTHOR_HIGHLIGHTS,
  DID_YOU_KNOW,
  INDUSTRY_BENCHMARK_STANDINGS,
  ORGANIZATION_BREAKDOWN,
  PULL_REQUEST_CONTRIBUTION,
};
